/**
 * adminConstants.js
 * Fuente centralizada de verdad para SuperAdministradores Master y Cuentas Demo.
 */

export const DEFAULT_ADMIN_EMAILS = [
  'sergio@seryiads.com',
  'sergioreinam@gmail.com',
  'estebanreinag@gmail.com'
];

// Correos que NO son del dueño del sistema y no deben ser administradores (sergarts@ y ser.garts@ son el mismo buzón de Gmail: Gmail ignora los puntos).
// Aunque un navegador conserve una lista vieja en localStorage, se descartan. La barrera real está en la base (tabla master_admins, migración 20261007c).
export const REVOKED_ADMIN_EMAILS = ['sergarts@gmail.com', 'ser.garts@gmail.com'];
const isRevoked = (e) => REVOKED_ADMIN_EMAILS.includes(String(e).trim().toLowerCase());

export const DEMO_ACCOUNTS = [
  {
    id: 'demo-barber',
    legacyIds: ['9001'],
    name: 'Barberya Demo (Keyla)',
    type: 'barberia',
    niche: 'Servicios, Barbería y Spa',
    demoEmail: 'barberiademo@seryiads.com',
    demoPassword: 'demo',
    slug: 'barberia-demo',
    icon: '💈',
    primaryColor: '#10B981',
    description: 'Flujo completo de servicios con duración, staff/especialistas y agendamiento interactivo.',
    features: ['feature_appointments', 'feature_services', 'feature_staff', 'feature_finanzas', 'feature_loyalty', 'feature_campaigns']
  },
  {
    id: 'demo-restaurante',
    legacyIds: ['9002'],
    name: 'Restaurante Demo (Keyla)',
    type: 'restaurante',
    niche: 'Gastronomía & Domicilios',
    demoEmail: 'restaurantedemo@seryiads.com',
    demoPassword: 'demo',
    slug: 'restaurante-demo',
    icon: '🍔',
    primaryColor: '#F59E0B',
    description: 'Menú digital QR, carrito de compras, pedidos por WhatsApp, pantalla de cocina y comisiones de delivery.',
    features: ['feature_orders', 'feature_inventory', 'feature_menu_media', 'feature_commissions', 'feature_finanzas']
  },
  {
    id: 'demo-agendamiento',
    legacyIds: ['9003'],
    name: 'Agendamiento Demo (Keyla)',
    type: 'clinica',
    niche: 'Salud, Estética & Consultas',
    demoEmail: 'agendamientodemo@seryiads.com',
    demoPassword: 'demo',
    slug: 'agendamiento-demo',
    icon: '🩺',
    primaryColor: '#6366F1',
    description: 'Agendamiento de citas especializadas, sincronización con Google Calendar y recordatorios automáticos.',
    features: ['feature_appointments', 'feature_services', 'feature_staff', 'feature_finanzas']
  }
];

export const getStoredAdminEmails = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const saved = window.localStorage.getItem('keylacrm_admin_emails');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed) && parsed.length > 0) {
          // Aseguramos que seryiads@gmail.com no se re-infiltre si el usuario lo eliminó
          return parsed.filter(e => typeof e === 'string' && e.trim() !== '' && !isRevoked(e));
        }
      } catch (e) {
        console.warn("Error leyendo admin emails de localStorage:", e);
      }
    }
  }
  return DEFAULT_ADMIN_EMAILS;
};

export const saveStoredAdminEmails = (emails) => {
  if (typeof window !== 'undefined' && window.localStorage && Array.isArray(emails)) {
    window.localStorage.setItem('keylacrm_admin_emails', JSON.stringify(emails));
  }
};

export const isDemoId = (id) => {
  if (!id) return false;
  const strId = String(id);
  return DEMO_ACCOUNTS.some(d => d.id === strId || d.legacyIds.includes(strId));
};

export const findDemoMatch = (identifier) => {
  if (!identifier) return null;
  const clean = String(identifier).trim().toLowerCase();
  return DEMO_ACCOUNTS.find(d => 
    d.id.toLowerCase() === clean ||
    d.demoEmail.toLowerCase() === clean ||
    d.slug.toLowerCase() === clean ||
    d.legacyIds.includes(clean)
  ) || null;
};
